// extracted by mini-css-extract-plugin
export default {"about-us":"AboutUs_about-us__jdYDd","qualities":"AboutUs_qualities__aa8m0","visualizer":"AboutUs_visualizer__MTE9B","about-us-img":"AboutUs_about-us-img__rYurS"};